import BugsnagPerformance from '@bugsnag/browser-performance';

const shouldStartBugsnagPerformance =
  typeof window !== 'undefined' &&
  process.env.NODE_ENV !== 'development' &&
  !!process.env.NEXT_PUBLIC_BUGSNAG_API_KEY;

if (shouldStartBugsnagPerformance) {
  BugsnagPerformance.start({
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY as string,
  });
}

export default BugsnagPerformance;
